import { store } from '@jobcost-monorepo/crud';
import { SplashScreen } from '@jobcost-monorepo/ui';
import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import AppRouter from './routers';
import './styles.css';
import { I18nextProvider } from 'react-i18next';
import { i18nConfig } from '@jobcost-monorepo/i18n';

const getApp = () => {
  return (
    <Provider store={store}>
      <I18nextProvider i18n={i18nConfig}>
        <Suspense fallback={<SplashScreen />}>
          <AppRouter />
        </Suspense>
      </I18nextProvider>
    </Provider>
  );
};

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  getApp(),
);
